import { FC, useState } from 'react'
import { useHistory } from 'react-router-dom'

import './style.scss'
import CONFIG from '../../../../config'
import { FormResponseStatus } from '../../../models'
import { LayoutHome } from '../../../containers'
import { Button, Title, Text, AlertBrowser } from '../../../components/UI'
import { ModalAuth } from '../../../components/UI/Modal'
import { Login } from '../../../components'

const AdminHomePage:FC = ()  => {
  const history = useHistory()
  const [option, setOption] = useState(0)

  const redirect = (url: string) => history.push(url)

  const onSubmitStatus = (status: FormResponseStatus) => {
    if(status === 'SUCCESS') {
      redirect('/admin/usuarios')
    } else {
      setOption(1)
    }
  }

  return (
    <LayoutHome role="ADMIN_ROLE">
      {option === 0 &&
        <div className="mt-60">
          <Title component="h2" size="20" weight="bold" align="center">Iniciar sesión</Title>

          <Login role="ADMIN_ROLE" className="mt-50" onSubmit={(status) => onSubmitStatus(status)} />
        </div>
      }

      {option === 1 &&
        <div className="text-center mt-30">
          <Title component="h2" color="gray-300" size="20" weight="bold">Iniciar sesión</Title>
          <Text weight="semibold" className="mt-50">Usuario o contraseña inválida</Text>

          <Button fullWidth className="mt-50 lg:mt-60" onClick={() => setOption(0)}>REINTENTAR</Button>

          <Button component="link" to={`${CONFIG.ROUTES.ADMIN.FORGOTPASSWORD}`} fullWidth className="mt-30">RECUPERAR CONTRASEÑA</Button>
        </div>
      }

      <ModalAuth />
    </LayoutHome>
  )
}

export { AdminHomePage }